<template>
  <div class="flex xl:hidden flex-1 leading-none z-20">
    <button type="button"
            role="button"
            aria-label="Menu toggle"
            aria-haspopup="true"
            :aria-expanded="isMenuOpen.toString()"
            class="flex items-center text-primary-red"
            @click="openMenu()"
    >
      <span v-if="!isMenuOpen" class="ltr:mr-2 rtl:ml-2">{{ model.menuTitle }}</span>
      <span v-if="isMenuOpen" class="ltr:mr-2 rtl:ml-2">{{ model.menuClose }}</span>

      <div class="c-main-menu__button-icon"
           :title="model.menuTitle"
           :class="{ 'is-menu-opened': isMenuOpen, 'flip-x': direction === 'rtl' }"
      >
        <span class="c-main-menu__button-line-1" />
        <span class="c-main-menu__button-line-2" />
        <span class="c-main-menu__button-line-3" />
      </div>
    </button>

    <transition enter-active-class="transition-all duration-300"
                leave-active-class="transition-all duration-300"
                enter-class="opacity-0 invisible"
                enter-to-class="opacity-100 visible"
                leave-class="opacity-100 visible"
                leave-to-class="opacity-0 invisible"
    >
      <div v-show="isMenuOpen">
        <div ref="mainMenu" class="absolute top-0 left-0 h-screen w-full z-30 bg-white border-t border-beige mt-20 overflow-y-auto scrolling-touch">
          <ul class="mb-20">
            <li
              v-for="(item, index) in model.menuItems"
              :key="index"
              class="text-3xl border-b border-beige"
            >
              <a
                :href="item.url"
                :class="getSelectedCss(item.url, index)"
                class="flex items-center justify-between relative py-6 pl-4 pr-8 group"
              >
                <span class="absolute top-0 left-0 h-full bg-primary-red w-1 transform duration-200 -translate-x-2 group-hover:translate-x-0" />
                <span>{{ item.name }}</span>
                <span v-if="direction === 'rtl'" class="icon-arrow-left text-sm text-primary-red transform duration-200 group-hover:-translate-x-2" />
                <span v-else class="icon-arrow-right text-sm transform duration-200 text-primary-red group-hover:translate-x-2" />
              </a>
            </li>
            <li v-if="model.adimoButton" class="pl-4 pr-8">
              <AdimoButton :model="model.adimoButton" />
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import AdimoButton from '@/components/AdimoButton.vue'

export default {
  components: {
    AdimoButton
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    direction: {
      type: String,
      default: 'ltr'
    }
  },
  data() {
    return {
      mainMenu: null,
      isMenuOpen: false
    }
  },
  mounted() {
    this.mainMenu = this.$refs.mainMenu
  },
  methods: {
    openMenu() {
      this.isMenuOpen = !this.isMenuOpen

      if (this.isMenuOpen) {
        disableBodyScroll(this.mainMenu)
      } else {
        enableBodyScroll(this.mainMenu)
      }
    },
    getSelectedCss(url, index) {
      if (this.model.currentUrl == this.model.homeUrl || index == 0) {
        return url == this.model.currentUrl ? 'text-primary-red' : ''
      }

      return this.model.currentUrl && this.model.currentUrl.startsWith(url) ? 'text-primary-red' : ''
    }
  }
}
</script>
